import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import { Form, actions } from 'react-redux-form/immutable';
import { Fieldset, Row, Field } from 'react-gridforms';
import Input from 'bisu-react-input';

import FieldGroupRow from 'components/FieldGroupRow';
import InputSelect from 'components/InputSelect';
import InputRadio from 'components/InputRadio';
import DefaultProfile from 'assets/img/default-profile.png';
import CivilStatus from 'constants/civil_status';
import Sex from 'constants/sex';
import { required } from 'utils/validators';

const validators = {
  last_name: { required },
  first_name: { required },
  sex: { required },
  dob: { required },
  civil_status: { required },
  email: { required },
};

class FormStudent extends Component {
  _onBlur = (e) => {
    if (!this.props.__item.get('id')) {
      this._setUserAndEmail();
    }
  };

  _setUserAndEmail() {
    const { dispatch, __item } = this.props;
    const username = (__item.get('first_name') + '.' + __item.get('last_name'))
      .toLowerCase()
      .replace(/\s/g, '')
      .replace('ñ', 'n');
    const email = username + '@bisu.edu.ph';
    dispatch(actions.change('studentState.username', username));
    dispatch(actions.change('studentState.email', email));
  }

  render() {
    const { __item, onSubmit } = this.props;

    return (
      <Form
        model='studentState'
        className='grid-form'
        validators={validators}
        onSubmit={onSubmit}
      >
        <div className='m-b-20 text-right'>
          <button type='submit' className='btn btn-success'>
            Save Student
          </button>
          <hr />
        </div>
        <div className='row'>
          <div className='col-sm-9'>
            <Fieldset legend='Basic Information'>
              <FieldGroupRow
                model='.last_name'
                label='Last Name'
                onBlur={this._onBlur}
                required
                autoFocus
              />
              <FieldGroupRow
                model='.first_name'
                label='First Name'
                onBlur={this._onBlur}
                required
              />
              <Row>
                <Field span='3'>
                  <Input model='.middle_name' label='Middle Name' />
                </Field>
                <Field span='1'>
                  <Input model='.suffix_name' label='Ext Name' />
                </Field>
              </Row>
              <Row>
                <Field>
                  <Input
                    model='.dob'
                    label='Date of Birth'
                    placeholder='Jan 1, 2000'
                    required
                  />
                </Field>
                <Field>
                  <InputRadio model='.sex' label='Sex' options={Sex} required />
                </Field>
                <Field>
                  <InputSelect
                    model='.civil_status'
                    label='Civil Status'
                    options={CivilStatus}
                    required
                  />
                </Field>
              </Row>
            </Fieldset>
          </div>
          <div className='col-sm-3'>
            <Fieldset legend='Account Information'>
              <div className='text-center'>
                <img
                  className='profile-pic img-rounded'
                  src={
                    __item.get('photo') ? __item.get('photo') : DefaultProfile
                  }
                  alt={__item.get('id')}
                />
                {__item.get('id') !== 0 && (
                  <h6>
                    ID #: <kbd>{__item.get('id')}</kbd>
                  </h6>
                )}
                <hr />
              </div>
              <FieldGroupRow model='.username' label='Username' required />
              <FieldGroupRow model='.email' label='Email Address' required />
              <FieldGroupRow model='.photo' label='Photo URL (500x500px)' />
            </Fieldset>
          </div>
        </div>
        <Fieldset legend='Personal Information'>
          <Row>
            <Field span='3'>
              <Input model='.address' label='Permanent Address' />
            </Field>
            <Field span='1'>
              <Input model='.zip' label='Zip Code' />
            </Field>
          </Row>
          <Row>
            <Field>
              <Input model='.meta.contact1' label='Mobile # (639123456789)' />
            </Field>
          </Row>
        </Fieldset>
        <Fieldset legend='Education Background'>
          <Row>
            <Field span='3'>
              <Input model='.meta.intermediate_name' label='Intermediate' />
            </Field>
            <Field>
              <Input model='.meta.intermediate_sy' label='School-Year' />
            </Field>
          </Row>
          <FieldGroupRow
            model='.meta.intermediate_address'
            label='Intermediate School Address'
          />
          <Row>
            <Field span='3'>
              <Input model='.meta.secondary_name' label='Secondary' />
            </Field>
            <Field>
              <Input model='.meta.secondary_sy' label='School-Year' />
            </Field>
          </Row>
          <FieldGroupRow
            model='.meta.secondary_address'
            label='Secondary School Address'
          />
        </Fieldset>
      </Form>
    );
  }
}

FormStudent.propTypes = {
  __item: PropTypes.object,
  onSubmit: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    __item: state.studentState,
  };
}

export default connect(mapStateToProps)(FormStudent);



// WEBPACK FOOTER //
// ./src/containers/Students/form-student.js